import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebaseConfig";

import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const AdminUploadPoza = () => {
  const [file, setFile] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Selectează o poză înainte de a încărca!");
      return;
    }

    try {
      setUploading(true);
      const storage = getStorage();
      const fileName = `${Date.now()}_${file.name}`;
      const storageRef = ref(storage, `imagini_admin/${fileName}`);

      // 🔹 Încarcă fișierul în Firebase Storage
      // 🔹 Obține URL-ul descărcabil
      // 🔹 Salvează URL-ul în Firestore
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      await addDoc(collection(db, "poze_admin"), {
        url: downloadURL,
        nume: file.name,
        path: `imagini_admin/${fileName}`, // ✅ salvăm calea exactă din Storage
        uploadedAt: serverTimestamp(),
      });

      // ✅ Afișează pop-up de confirmare
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);

      // Resetare
      setFile(null);
      setUploading(false);
    } catch (error) {
      console.error("❌ Eroare la upload:", error);
      alert("Eroare la încărcarea pozei!");
      setUploading(false);
    }
  };

  return (
    <div className="admin-card-photo admin-poza relative">
      <h3 className="admin-card-header">Adaugă poză</h3>

      <label htmlFor="upload-poza" className="admin-upload-box">
        {file ? (
          <p className="text-green-400 text-center">{file.name}</p>
        ) : (
          <p className="text-center">
            Trage o poză aici sau apasă pentru a încărca
          </p>
        )}
        <input
          id="upload-poza"
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleFileChange}
        />
      </label>

      <button
        className="admin-button"
        onClick={handleUpload}
        disabled={uploading}
      >
        {uploading ? "Se încarcă..." : "Încarcă"}
      </button>

      {/* POP-UP SUCCES */}
      {showPopup && (
        <div className="admin-popup">✅ Poză adăugată cu succes!</div>
      )}
    </div>
  );
};

export default AdminUploadPoza;
